import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Response } from '../../shared/models/response.model';
import { Site } from './model/site.model';
import { SiteCreateRequest } from './request/create-request';
import { SiteUpdateRequest } from './request/update-request';

@Injectable({
  providedIn: 'root',
})
export class SiteService {
  #http = inject(HttpClient);

  readonly BASE_URL = '/sites';

  trouverTous = (idCartographie: string) => {
    return this.#http.get<Response<Site>>(this.BASE_URL, { params: { idCartographie } });
  };

  trouverParId = (id: string) => {
    return this.#http.get<Site>(this.BASE_URL + '/' + id);
  };

  modifier = (id: string, site: SiteUpdateRequest) => {
    return this.#http.put<Site>(this.BASE_URL + '/' + id, site);
  };

  créer = (request: SiteCreateRequest) => {
    return this.#http.post(this.BASE_URL, request);
  };

  supprimer = (id: string) => {
    return this.#http.delete<void>(this.BASE_URL + '/' + id);
  };
}
